import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import style from "./header.module.scss";

import FancyButton from "./Content/InfoPages/PageContent/Common/FancyButton";

function Header() {
  const [curpath, setCurpath] = useState("");

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    var fullHeader = document.querySelector("#fullheader");
    var topHeader = document.querySelector(".header-custom-r1");
    var lowerHeader = document.querySelector("." + style.headerLowerCnt);
    var top = lowerHeader.offsetTop;

    window.onscroll = (e) => {
      if (window.pageYOffset > top) {
        topHeader.style.display = "none";
        fullHeader.style.position = "fixed";
      } else {
        fullHeader.style.position = "absolute";
        topHeader.style.display = "flex";
      }
    };
  }, []);

  useEffect(() => {
    setCurpath(location.pathname);
  }, [location.pathname]);

  return (
    <header className="nav-header container-fluid" id="fullheader">
      <div className="row header-custom-r1">
        <div className="col-4 menu-bg-sc">
          <p className="text-left">
            Alle nieuwbouw aan de Costa Blanca en de Costa del Sol
          </p>
        </div>
        <div className="col-3">
          <a href="#" className="blacks">
            T. 00 34 678 90 65 43
          </a>
        </div>
        <div className="col-3">
          <a href="#" className="blacks">
            info@vhenga.com
          </a>
        </div>
        <div className="col-1">
          <a href="#" className="text-center m-auto reds">
            <i className="fa fa-sm fa-facebook m-auto reds"></i>
          </a>
        </div>
        <div className="col-1">
          <a href="#">
            <i className="fa fa-s, fa-instagram m-auto reds"></i>
          </a>
        </div>
      </div>

      <div className={"row " + style.headerLowerCnt}>
        <div className={style.vhengalogoCnt} style={{ opacity: 0 }}>
          <div className={style.imgCnt}>
            <img src="./Images/logo.png" alt="" className="header-icon" />
          </div>
          <div
            className="header-logotexts"
            onClick={(e) => {
              history.push("/");
            }}
          >
            {/* <Link> */}
            <h2 className="vhenga m-auto">VHENGA</h2>
            <h6>&nbsp; &nbsp; VOEL Je de zon AL</h6>
            {/* </Link> */}
          </div>
        </div>

        <div className={style.fancyButtonsCnt}>
          <FancyButton
            middle="Vastgoed Vinder"
            upper="direct naar"
            lower="klik hier"
          />
          {/* <FancyButton
            middle="Gratis Magazine"
            upper="graag een"
            lower="klik hier"
            bk="#3e6373"
            to="/magazine"
          /> */}
        </div>

        <div className="d-flex h-100 justify-content-end align-items-center menu-bg-sc">
          <ul className="header-menus m-0 h-100 d-flex" id="collapsibleNavbar">
            <Link
              className={"m-auto " + style.menuItem}
              to="/"
              style={{
                color: curpath == "/" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Welkom
            </Link>
            <Link
              className={"m-auto " + style.menuItem}
              to="/alles"
              style={{
                color: curpath == "/alles" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Alles Weten
            </Link>
            <Link
              className={"m-auto " + style.menuItem}
              to="/welcome"
              style={{
                color: curpath == "/welcome" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Villas
            </Link>
            <Link
              className={"m-auto " + style.menuItem}
              to="/welcome"
              style={{
                color: curpath == "/welcome" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              10%
            </Link>
            {/* <Link className="m-auto" to="/purchases" style={{ color: (curpath == "/purchases") ? "#a89f87" : "", fontWeight: "bold" }}>
                            Aankopen
                        </Link> */}
            {/* <Link className="m-auto" to="/service" style={{ color: (curpath == "/service") ? "#a89f87" : "", fontWeight: "bold" }}>
                            Service
                        </Link> */}
            {/* <Link className="m-auto" to="/regio" style={{ color: (curpath == "/regio") ? "#a89f87" : "", fontWeight: "bold" }}>
                            Regio & service
                        </Link> */}
            <Link
              className={"m-auto " + style.menuItem}
              to="/news"
              style={{
                color: curpath == "/news" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Video
            </Link>
            <Link
              className={"m-auto " + style.menuItem}
              to="/contact"
              style={{
                color: curpath == "/contact" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Contact
            </Link>
            <a
              className={"m-auto " + style.menuItem}
              href="https://trxn-apc.web.app/nl?soid=gGLK9tgFhlrPVDvQrPKi"
              style={{
                color: curpath == "/contact" ? "#a89f87" : "",
                fontWeight: "bold",
              }}
            >
              Spanje
            </a>
            {/* <li className="m-auto"><Link to="#" style={{color:(curpath=="#")?"rgb(243 106 75)":""}}>Nieuws</Link></li>
                            <li className="m-auto last-childli"><Link to="/contact"  style={{color:(curpath=="/contact")?"rgb(243 106 75)":""}}>Contact</Link></li> */}
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
